"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageSkeleton = exports.Image = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Image = exports.Image = (0, _mui.styled)(_components.LazyImage)({
    height: _constants.OVERVIEW_IMAGE_HEIGHT,
    maxWidth: 165,
    objectFit: 'cover',
    padding: 0
});
const ImageSkeleton = exports.ImageSkeleton = (0, _mui.styled)(_mui.Skeleton)({
    height: _constants.OVERVIEW_IMAGE_HEIGHT,
    width: 160
});
